var _excluded = ["activeMonth", "goToPreviousMonth", "goToNextMonth", "hasPreviousMonth", "hasNextMonth", "openYearSelection", "nextMonthLabels", "previousMonthLabels", "shouldFocusYearSelectionTrigger"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef, useEffect, useRef } from 'react';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { IconButton } from '../../../../action';
import { Box } from '../../../Box';
import { useCalendarContext } from '../../CalendarContext';
import { YearSelectionHeaderTrigger } from '../YearSelection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Header = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    activeMonth,
    goToPreviousMonth,
    goToNextMonth,
    hasPreviousMonth,
    hasNextMonth,
    openYearSelection,
    nextMonthLabels,
    previousMonthLabels,
    shouldFocusYearSelectionTrigger
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    size,
    isDisabled,
    isMobileDatePicker,
    showYearSelection
  } = useCalendarContext();
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  }); // This is used to returns the focus to trigger button when the year selection is closed and the header is visible.

  var triggerYearSelectionBtnRef = useRef(null);
  useEffect(() => {
    if (shouldFocusYearSelectionTrigger) {
      var _triggerYearSelection;

      (_triggerYearSelection = triggerYearSelectionBtnRef.current) === null || _triggerYearSelection === void 0 ? void 0 : _triggerYearSelection.focus();
    }
  }, [shouldFocusYearSelectionTrigger]);

  var getNextPrevMonthActionLabel = (direction, labelsDate) => {
    if (!labelsDate) return "".concat(direction, " month is not available");
    return "".concat(direction, " month ").concat(labelsDate === null || labelsDate === void 0 ? void 0 : labelsDate.full, " ").concat(labelsDate === null || labelsDate === void 0 ? void 0 : labelsDate.year);
  };

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    __css: styles['header']
  }, props), {}, {
    // Hides the header when the year selection is open to prevent focus issues (necessary for a11y)
    "data-hidden": showYearSelection || null,
    ref: ref,
    children: [/*#__PURE__*/_jsx(Box, {
      as: IconButton,
      "data-testid": "calendar-previous-month-button",
      onClick: goToPreviousMonth,
      "aria-label": getNextPrevMonthActionLabel('Previous', previousMonthLabels),
      __css: styles['monthHeaderNavigationBtn'] // ts-ignore is used due to `IconButton`'s props issues with `<Box/>`.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      ,
      size: "large",
      variant: "naked",
      icon: "chevron-left",
      isDisabled: isDisabled || !hasPreviousMonth,
      type: "button",
      "aria-hidden": true
    }), /*#__PURE__*/_jsx(YearSelectionHeaderTrigger, {
      activeMonth: activeMonth,
      toggleYearSelection: openYearSelection,
      "data-testid": "year-selection-header-open-trigger",
      ref: triggerYearSelectionBtnRef // Is used for a11y reasons to update the calendar's title when the date changes
      ,
      "aria-live": "polite"
    }), /*#__PURE__*/_jsx(Box, {
      as: IconButton,
      "data-testid": "calendar-next-month-button",
      "aria-label": getNextPrevMonthActionLabel('Next', nextMonthLabels),
      onClick: goToNextMonth,
      __css: styles['monthHeaderNavigationBtn'] // ts-ignore is used due to `IconButton`'s props issues with `<Box/>`.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      ,
      variant: "naked",
      isDisabled: isDisabled || !hasNextMonth,
      icon: "chevron-right",
      size: "large",
      type: "button",
      "aria-hidden": true
    })]
  }));
});
//# sourceMappingURL=Header.js.map